import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import css from './LandingPage.module.css';
import { Button } from '../../components';

const DynamicBanner = ({ configUrl }) => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    fetch(configUrl)
      .then(res => res.json())
      .then(setBanners)
      .catch(err => console.error('Błąd pobierania bannerów:', err));
  }, [configUrl]);

  if (!banners.length) return null;

  return banners.map((banner, index) => (
    <div className={css.sectionBanner} key={index}>
      <div className={css.bannerWrapper}>
        <img
          src={banner.desktopImage}
          alt={`Banner ${index} desktop`}
          className={`${css.bannerImage} ${css.desktopOnly}`}
          onClick={() => window.open(banner.redirectUrl, '_blank')}
        />
        <img
          src={banner.mobileImage}
          alt={`Banner ${index} mobile`}
          className={`${css.bannerImage} ${css.mobileOnly}`}
          onClick={() => window.open(banner.redirectUrl, '_blank')}
        />
      </div>
      <Button
        className={css.bannerButton}
        onClick={() => window.open(banner.redirectUrl, '_blank')}
      >
        <FormattedMessage id="SectionBanner.CTA" />
      </Button>
    </div>
  ));
};

export default DynamicBanner;
